export type TNativeOscillatorNode = OscillatorNode;
